import { getTabs } from '../../AdminBinder/placeholderData';

export const getProvidersListTab = () => {
  return getTabs(false).find((tab) => tab.name === 'Print Providers');
};
